import React from 'react';

export default function StepConversion() {
  return (
    <div className="ob-step-enter ob-conv">
      <div className="ob-conv-card">
        <div className="ob-conv-punkt ob-conv-punkt--border">
          <span className="ob-conv-titel">Kostenlos Ausprobieren</span>
          <span className="ob-conv-sub">Deine ersten drei Bewerbungen gehen auf uns. Ohne Verpflichtungen.</span>
        </div>
        <div className="ob-conv-punkt">
          <span className="ob-conv-titel">Ganz entspannt testen</span>
          <span className="ob-conv-sub">Schau dir in Ruhe an, ob CVFlow zu dir passt. Du entscheidest erst danach, ob du weitermachen möchtest.</span>
        </div>
      </div>

      <p className="ob-conv-hinweis">Nur noch ein Schritt bis zu deiner ersten Bewerbung.</p>
    </div>
  );
}
